module.exports = __webpack_public_path__ + "static/img/testimony (17).9052468a.jpg";